import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '#src/app/App';

const root = document.getElementById('root');
if (root === null) {
  throw new Error('index.html sem o elemento #root');
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
